export enum GenShippingAccountType {
    GENERAC = 'GENERAC',
    DEALER = 'DEALER',
}
